import * as React from "react";

function TickIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx={9} cy={9} r={9} fill="#009739" />
        <path
          fill="#FFF"
          d="M14.314 7.371l-6.076 5.832c-.412.396-1.096.396-1.522 0l-3.031-2.91a1.016 1.016 0 010-1.461c.412-.396 1.096-.396 1.522 0l2.283 2.191 5.315-5.1c.412-.397 1.096-.397 1.522 0 .4.396.4 1.052-.013 1.448z"
        />
      </g>
    </svg>
  );
}

const MemoTickIcon = React.memo(TickIcon);
export default MemoTickIcon;
